import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m12,18.2c.2,0,.5-.1.7-.3.5-.7,5.1-7,5.1-9.9,0-1.5-.6-3-1.7-4.1-1.1-1.1-2.6-1.7-4.1-1.7s-3,.6-4,1.7c-1.1,1.1-1.7,2.6-1.7,4.1,0,2.9,4.6,9.2,5.1,9.9.1.2.4.3.6.3Zm-3-13.2c.8-.8,1.9-1.2,3-1.2s2.2.4,3,1.2,1.2,1.9,1.2,3c0,1.8-2.6,6-4.2,8.2-1.5-2.2-4.2-6.4-4.2-8.2,0-1.1.4-2.2,1.2-3Z"
          stroke-width="0"
        />
        <circle cx="12" cy="8" r="1.7" stroke-width="0" />
        <path
          d="m19,12.7h-1.5c-.5,0-.8.3-.8.8s.4.8.8.8h1.5c1.2,0,2.2,1,2.2,2.2v1.5c0,1.2-1,2.2-2.2,2.2H5c-1.2,0-2.2-1-2.2-2.2v-1.5c0-1.2,1-2.2,2.2-2.2h1.5c.5,0,.8-.3.8-.8s-.4-.8-.8-.8h-1.5c-2.1,0-3.8,1.7-3.8,3.8v1.5c0,2.1,1.7,3.8,3.8,3.8h14c2.1,0,3.8-1.7,3.8-3.8v-1.5c0-2.1-1.7-3.8-3.8-3.8Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
